import { HERO_BG, EMBLEM_CIRCLE } from "@/lib/sps-content";
import { ArrowRight } from "lucide-react";

export const Hero = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="inicio"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center overflow-hidden bg-[#001825]"
    >
      {/* Background: industrial bottling machinery */}
      <div className="absolute inset-0 z-0">
        <img
          src={HERO_BG}
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-32 md:py-40 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          {/* LEFT — headline + CTA */}
          <div className="lg:col-span-7">
            <h1
              data-testid="hero-title"
              className="font-sans-modern font-light text-white text-[2.5rem] md:text-[3rem] leading-[1.1] tracking-tight uppercase"
            >
              Operamos soluciones integrales para la transformación del Agave.
            </h1>

            <div className="mt-12">
              <button
                data-testid="hero-cta-primary"
                onClick={() => scrollTo("servicios")}
                className="group inline-flex items-center gap-4 px-8 py-4 border border-[#8f9194]/60 text-[#f8f9fa] text-xs uppercase tracking-[0.25em] hover:border-[#8f9194] hover:bg-[#8f9194]/10 transition-all duration-300"
              >
                Conoce nuestras unidades de negocio
                <ArrowRight
                  size={16}
                  strokeWidth={1.5}
                  className="transition-transform duration-300 group-hover:translate-x-1"
                />
              </button>
            </div>
          </div>

          {/* RIGHT — metallic SPS emblem */}
          <div className="hidden lg:flex lg:col-span-5 justify-end items-center">
            <div className="relative">
              <div className="absolute inset-0 rounded-full bg-[#3a6f99]/20 blur-3xl scale-110" />
              <img
                src={EMBLEM_CIRCLE}
                alt="SPS Emblem"
                className="relative h-[420px] w-[420px] xl:h-[480px] xl:w-[480px] object-contain mix-blend-screen drop-shadow-[0_0_60px_rgba(143,145,148,0.3)]"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
